import React from 'react';
import AboutMe from '../Assets/AboutMe.jpg';
import styled from 'styled-components';
import data from '../Assets/data.json';
import 'bootstrap/dist/css/bootstrap.min.css';

const Wrapper = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    margin: 3rem 0;
  }

  @media (min-width: 769px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 2rem 6%;
  }

  @media (min-width: 1025px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin: 0 21%;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: justify;

  @media (max-width: 768px) {
    padding: 5% 10%;
  }

  @media (min-width: 769px) {
    padding: 0 10%;
  }

  @media (min-width: 1025px) {
    padding: 0 20%;
  }
`;

const Title = styled.h2`
  font-weight: bolder;
  margin-bottom: 1rem;
`;

const AboutSection = () => {
	return (
		<Wrapper>
			<img className='d-block w-100 h-100' alt="About me" src={AboutMe}/>
			<Container>
				<Title>{data.about.title}</Title>
				<span>Na&nbsp;co&nbsp;dzień jestem żoną, matką dwójki wspaniałych dzieci, od&nbsp;wielu lat pracuję zawodowo w&nbsp;branży nieruchomości, jednak zarówno w&nbsp;pracy zawodowej jak i&nbsp;życiu osobistym zawsze bardzo dużo miejsca zajmowały i&nbsp;nadal zajmują spotkania i&nbsp;rozmowy „o&nbsp;życiu”. To&nbsp;spowodowało, że&nbsp;w&nbsp;2016&nbsp;roku ukończyłam studia coachingowe w&nbsp;Wyższej Szkole Bankowej. Od&nbsp;zawsze staram się pomagać innym, udzielam się w&nbsp;wolontariacie w&nbsp;środowisku problemowym. W&nbsp;wolnym czasie spaceruję, jeżdżę na&nbsp;rowerze, podróżuję, kocham przyrodę, lubię dobry film i&nbsp;muzykę. Wierzę, że&nbsp;każdy człowiek ma&nbsp;talent, czasem bardzo ukryty i&nbsp;tylko trzeba do&nbsp;niego dotrzeć. Serdecznie zapraszam na&nbsp;spotkanie.</span>
			</Container>
		</Wrapper>
	);
};

export default AboutSection;
